import { gql } from '@apollo/client';

export const CREATE_PROXY_OBJECT = gql`
    mutation createProxyObject($input:CreateProxyObjectInput!){
        result:createProxyObject(input:$input){
        id
        fieldData
        companyIntegrationId
        }
    }
`;